import { EventListeners, MinzeElement, Reactive, Attrs } from 'minze'
import { Font } from '../../constants'
import { Callback } from '../../modules/callback'
import { Locale } from '../../modules/locale'
import { AdditionalTypes } from '../../modules/additionalTypes'
import { delay } from '../../modules/utils'

Locale.getInstance().registerKeySet('fr', 'lvc-start-end-time-input-field', {
  startTimeLabel: 'de',
  endTimeLabel: 'à',
  title: 'Horaire*',
})

Locale.getInstance().registerKeySet('en', 'lvc-start-end-time-input-field', {
  startTimeLabel: 'from',
  endTimeLabel: 'to',
  title: 'Time*',
})

export interface LvcStartEndTimeInputField {
  title: string
  placeholder: string
  open: boolean
  onChange: string
  defaultValue: any
  value: string
}
const startTime: string = ''

export class LvcStartEndTimeInputField extends MinzeElement {
  attrs: Attrs = [
    'title',
    'placeholder',
    ['onChangeStartTime'],
    ['onChangeEndTime'],
    ['default-value', ''],
    ['startTime', ''],
    ['endTime', ''],
  ]

  reactive: Reactive = [
    ['background', 'transparent'],
    ['startTimeValue', ''],
    ['endTimeValue', ''],
  ]

  static observedAttributes = ['startTime', 'endTime']

  async onReady() {
    if (this.startTime && this.startTime !== true) this.startTimeValue = this.startTime
    if (this.endTime && this.endTime !== true) this.endTimeValue = this.endTime
  }

  onStartTimeChange = async (event: any) => {
    this.startTimeValue = (event as any).detail.value
    Callback.call(this.onChangeStartTime as string, event.detail.value)
    this.rerender()
  }

  onEndTimeChange = async (event: any) => {
    this.endTimeValue = (event as any).detail.value
    Callback.call(this.onChangeEndTime as string, event.detail.value)
    this.rerender()
  }

  html = () => {
    return `

    <lvc-box display="flex" rowGap="4px" justifyContent="center" flexDirection="column" width="fit-content">

      <lvc-text font-preset="small" color="#1E007D" mt="5px">${Locale.getKey('lvc-start-end-time-input-field.title')}</lvc-text>

      <lvc-box class="container" display="flex" justifyContent="center" width="fit-content" >
        <div class="startTimeContainer">
          <lvc-timepicker
            name="startTime"
            width="80px"
            height="46px"
            value="${this.startTimeValue}"
            default-value="${this.startTimeValue}"
            background='${this.background}'
            placeholder='${Locale.getKey('lvc-start-end-time-input-field.startTimeLabel')}'
            placeholder-color='#1E007D'
            position='below'
          ></lvc-timepicker>
        </div>

        <div class="separator"></div>

        <div class="endTimeContainer">
          <lvc-timepicker
            name="endTime"
            width="80px"
            height="46px"
            value="${this.endTimeValue}"
            default-value="${this.endTimeValue}"
            background='${this.background}'
            placeholder='${Locale.getKey('lvc-start-end-time-input-field.endTimeLabel')}'
            placeholder-color='#1E007D'
            position='below'
          ></lvc-timepicker>
        </div>
      </lvc-box>
    </lvc-box>
      

    `
  }

  css = () => {
    return `
      :host {
      }


      .container {
        border: 1px solid #1E007D;
        border-radius: 99px;
        height: 48px;
        
      }

      .separator{
        width: 1px; 
        background-color: #1E007D;
      }

      .startTimeContainer{
        display: flex;
        align-items: center;
        gap: 4px;
      }




    `
  }

  eventListeners: EventListeners = [
    ['[name="startTime"]', 'change', this.onStartTimeChange.bind(this)],
    ['[name="endTime"]', 'change', this.onEndTimeChange.bind(this)],
  ]
}
